(function(){
  if (window.__alLoaded) return; window.__alLoaded = true;

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* ---------- Money (Shopify formats) ---------- */
  function alMoney(cents, format){
    if(typeof cents === 'string') cents = cents.replace('.','');
    format = format || '{{amount}}';
    function delim(n, precision, thousands, decimal){
      thousands = thousands === undefined ? ',' : thousands; decimal = decimal === undefined ? '.' : decimal;
      if(isNaN(n) || n == null) return '0';
      n = (n/100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? (decimal + parts[1]) : '';
      return dollars + c;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function(m, key){
      switch(key){
        case 'amount': return delim(cents, 2);
        case 'amount_no_decimals': return delim(cents, 0);
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_space_separator': return delim(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return delim(cents, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2);
      }
    });
  }
  window.alMoney = alMoney;
  var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Cart (add) ---------- */
  async function alAdd(id, qty, btn){
    if(!id) return;
    if(btn){btn.setAttribute('disabled','');}
    try{
      var res = await fetch(root_url + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id), quantity:Number(qty||1)}]})});
      var data = await res.json();
      if(!res.ok) throw new Error(data.description || 'add failed');
      if(window.alCart){ await window.alCart.refresh(true); }
      else { window.location.href = root_url + 'cart'; }
    }catch(e){
      if(window.alCart && e && e.message){ window.alCart.refresh(true); }
      else window.location.href = root_url + 'cart';
    }finally{ if(btn){btn.removeAttribute('disabled');} }
  }
  window.alAdd = alAdd;

  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-al-add]');
    if(b){ e.preventDefault(); var q = 1; var qi = b.dataset.qtyInput && document.querySelector(b.dataset.qtyInput); if(qi) q = qi.value; alAdd(b.dataset.variant, q, b); }
  });

  /* ---------- Cart drawer ---------- */
  function initCart(){
    var root = document.querySelector('[data-al-cart]'); if(!root || window.alCart) return;
    var fmt = root.dataset.moneyFormat || '{{amount}}';
    var m = function(c){ return alMoney(c, fmt); };
    var recs = [], tmap = {};
    try{ recs = JSON.parse(root.querySelector('[data-al-recs-json]').textContent); }catch(e){}
    try{ tmap = JSON.parse(root.querySelector('[data-al-title-map]').textContent); }catch(e){}
    var itemsEl = root.querySelector('[data-al-cart-items]');
    var recsBox = root.querySelector('[data-al-cart-recs]');
    var rail = root.querySelector('[data-al-recs-rail]');
    var track = root.querySelector('[data-al-recs-track]');
    var foot = root.querySelector('[data-al-cart-foot]');
    var lastFocus = null;
    function open(){ lastFocus = document.activeElement; document.body.classList.add('al-cart-open'); root.setAttribute('aria-hidden','false'); var x = root.querySelector('.al-cart__x'); if(x) x.focus(); }
    function close(){ document.body.classList.remove('al-cart-open'); root.setAttribute('aria-hidden','true'); if(lastFocus && lastFocus.focus) lastFocus.focus(); }
    function img(u, w){ if(!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w||160); }
    function render(cart){
      document.querySelectorAll('[data-al-cart-count]').forEach(function(b){ b.hidden = cart.item_count === 0; var s = b.querySelector('span'); if(s) s.textContent = cart.item_count; });
      var ship = root.querySelector('[data-al-cart-ship]');
      var thr = Number(root.dataset.threshold) || 0;
      var rate = Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
      var thrc = Math.round(thr * rate);
      if(ship){
        ship.hidden = cart.item_count === 0;
        var done = thrc <= 0 || cart.total_price >= thrc;
        root.querySelector('[data-al-cart-ship-text]').textContent = done ? root.dataset.msgDone : root.dataset.msgLeft.replace('[amount]', m(thrc - cart.total_price));
        root.querySelector('[data-al-cart-ship-bar]').style.width = done ? '100%' : Math.min(100, cart.total_price / thrc * 100) + '%';
      }
      if(!cart.items.length){
        itemsEl.innerHTML = '<div class="al-cart__empty"><p>' + esc(root.dataset.empty) + '</p><a class="al-btn" href="' + root_url + 'collections/all">Continue shopping</a></div>';
        foot.hidden = true;
      } else {
        foot.hidden = false;
        itemsEl.innerHTML = cart.items.map(function(it){
          var title = tmap[it.product_id] || it.product_title;
          var opts = (it.options_with_values || []).filter(function(o){ return o.value !== 'Default Title'; }).map(function(o){ return o.value.replace(/^1Pcs?-?\s*/,''); }).join(' / ');
          var old = it.original_line_price > it.final_line_price ? '<s>' + m(it.original_line_price) + '</s>' : '';
          var minus = it.quantity > 1 ? '<button type="button" data-al-q="' + (it.quantity-1) + '" data-key="' + esc(it.key) + '" aria-label="Decrease quantity">&minus;</button>' : '<button type="button" data-al-q="0" data-key="' + esc(it.key) + '" aria-label="Remove"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button>';
          return '<div class="al-cart__item"><a class="al-cart__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image)) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div><a class="al-cart__title" href="' + esc(it.url) + '">' + esc(title) + '</a>' + (opts ? '<div class="al-cart__var">' + esc(opts) + '</div>' : '') +
            '<div class="al-cart__qty">' + minus + '<span>' + it.quantity + '</span><button type="button" data-al-q="' + (it.quantity+1) + '" data-key="' + esc(it.key) + '" aria-label="Increase quantity">+</button></div></div>' +
            '<div class="al-cart__price">' + m(it.final_line_price) + old + '</div></div>';
        }).join('');
      }
      if(recsBox && rail){
        var inCart = cart.items.map(function(i){ return i.product_id; });
        var list = recs.filter(function(r){ return r.available && inCart.indexOf(r.product_id) === -1; });
        recsBox.hidden = list.length === 0;
        rail.innerHTML = list.map(function(r){
          return '<div class="al-cart__rec"><a class="al-cart__img" href="' + esc(r.url) + '">' + (r.image ? '<img src="' + esc(r.image) + '" alt="" loading="lazy">' : '') + '</a><div><b>' + esc(tmap[r.product_id] || r.title) + '</b>' + (r.option ? '<small>' + esc(r.option) + '</small>' : '') +
            '<div class="al-cart__rec-foot"><span>+ ' + esc(r.price) + '</span><button type="button" class="al-btn" data-al-add data-variant="' + r.variant_id + '">' + esc(root.dataset.add) + '</button></div></div></div>';
        }).join('');
        syncTrack();
      }
      root.querySelector('[data-al-cart-total]').textContent = m(cart.total_price);
      root.querySelector('[data-al-cart-count-sup]').textContent = cart.item_count;
    }
    function syncTrack(){
      if(!rail || !track) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var w = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth * 100 : 100;
      track.style.width = w + '%';
      track.style.left = (max > 0 ? rail.scrollLeft / max * (100 - w) : 0) + '%';
      var p = root.querySelector('[data-al-recs-prev]'), n = root.querySelector('[data-al-recs-next]');
      if(p) p.disabled = rail.scrollLeft <= 2; if(n) n.disabled = rail.scrollLeft >= max - 2;
    }
    if(rail) rail.addEventListener('scroll', function(){ requestAnimationFrame(syncTrack); }, {passive:true});
    async function refresh(openAfter){
      try{ var cart = await fetch(root_url + 'cart.js', {headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }); render(cart); }catch(e){}
      if(openAfter) open();
    }
    async function change(key, q){
      root.classList.add('is-busy');
      try{ var cart = await fetch(root_url + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({id: key, quantity: q})}).then(function(r){ return r.json(); }); render(cart); }catch(e){}
      root.classList.remove('is-busy');
    }
    root.addEventListener('click', function(e){
      var q = e.target.closest('[data-al-q]'); if(q){ change(q.dataset.key, Number(q.dataset.alQ)); return; }
      if(e.target.closest('[data-al-recs-prev]')) rail.scrollBy({left: -rail.clientWidth * .85, behavior:'smooth'});
      if(e.target.closest('[data-al-recs-next]')) rail.scrollBy({left: rail.clientWidth * .85, behavior:'smooth'});
    });
    document.addEventListener('click', function(e){
      if(e.target.closest('[data-al-cart-close]')){ e.preventDefault(); close(); return; }
      var o = e.target.closest('[data-al-cart-open]'); if(o){ e.preventDefault(); refresh(true); }
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && document.body.classList.contains('al-cart-open')) close(); });
    window.alCart = { open: open, close: close, refresh: refresh };
    refresh(false);
  }

  /* ---------- Header menus ---------- */
  function initMenus(){
    document.querySelectorAll('[data-al-menu]').forEach(function(item){
      if(item.__al) return; item.__al = true;
      var a = item.querySelector(':scope > a'); var t = null;
      function openM(){ clearTimeout(t); document.querySelectorAll('[data-al-menu].is-open').forEach(function(o){ if(o !== item){ o.classList.remove('is-open'); var oa = o.querySelector(':scope > a'); if(oa) oa.setAttribute('aria-expanded','false'); } }); item.classList.add('is-open'); a.setAttribute('aria-expanded','true'); document.body.classList.add('al-menu-open'); }
      function closeM(now){ clearTimeout(t); t = setTimeout(function(){ item.classList.remove('is-open'); a.setAttribute('aria-expanded','false'); if(!document.querySelector('[data-al-menu].is-open')) document.body.classList.remove('al-menu-open'); }, now ? 0 : 140); }
      item.addEventListener('mouseenter', openM);
      item.addEventListener('mouseleave', function(){ closeM(); });
      item.addEventListener('focusin', openM);
      item.addEventListener('focusout', function(e){ if(!item.contains(e.relatedTarget)) closeM(true); });
      a.addEventListener('click', function(e){ if(window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')){ e.preventDefault(); openM(); } });
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ document.querySelectorAll('[data-al-menu].is-open').forEach(function(o){ o.classList.remove('is-open'); }); document.body.classList.remove('al-menu-open'); } });
  }

  /* ---------- Carousels ---------- */
  function initRail(root){
    if(root.__al) return; root.__al = true;
    var rail = root.querySelector('[data-al-rail]'); if(!rail) return;
    var slides = Array.prototype.slice.call(rail.children);
    var dotsWrap = root.querySelector('[data-al-dots]');
    var counter = Array.prototype.slice.call(root.querySelectorAll('[data-al-count]'));
    var line = root.querySelector('.al-hero__line');
    function step(){ return slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap||0) : rail.clientWidth; }
    function idx(){ return Math.round(rail.scrollLeft / Math.max(1, step())); }
    function go(i){ var n = slides.length; if(i<0) i = n-1; if(i>=n) i = 0; rail.scrollTo({left: i*step(), behavior:'smooth'}); }
    var prev = root.querySelector('[data-al-prev]'), next = root.querySelector('[data-al-next]');
    if(prev) prev.addEventListener('click', function(){ go(idx()-1); });
    if(next) next.addEventListener('click', function(){ go(idx()+1); });
    var dots = [];
    if(dotsWrap){
      var pages = Math.max(1, slides.length - Math.round(rail.clientWidth/Math.max(1,step())) + 1);
      dotsWrap.innerHTML = '';
      if(pages > 1) for(var i=0;i<pages;i++){ (function(i){ var d=document.createElement('button'); d.type='button'; d.setAttribute('aria-label','Go to slide '+(i+1)); d.addEventListener('click',function(){go(i);}); dotsWrap.appendChild(d); dots.push(d); })(i); }
    }
    function sync(){
      var i = idx();
      dots.forEach(function(d,k){ d.setAttribute('aria-current', k===i ? 'true':'false'); });
      counter.forEach(function(c,k){ c.style.color = (k===i) ? 'var(--al-ink)' : ''; c.style.fontWeight = (k===i) ? '500' : ''; });
      if(line && counter[i] && counter[i].nextSibling !== line){ counter[i].parentNode.insertBefore(line, counter[i].nextSibling); }
    }
    rail.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, {passive:true});
    sync();
    var auto = Number(root.dataset.alAutoplay||0), timer = null, paused = false;
    var pauseBtns = root.querySelectorAll('[data-al-pause]');
    function start(){ if(auto && !paused){ stop(); timer = setInterval(function(){ go(idx()+1); }, auto*1000); } }
    function stop(){ if(timer) clearInterval(timer); timer = null; }
    pauseBtns.forEach(function(pauseBtn){ pauseBtn.addEventListener('click', function(){ paused = !paused; pauseBtns.forEach(function(p){ p.setAttribute('aria-pressed', paused); p.innerHTML = paused ? '&#9654;' : '&#10073;&#10073;'; }); paused ? stop() : start(); }); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- Video tiles + modal ---------- */
  document.addEventListener('click', function(e){
    var mv = e.target.closest('[data-al-vmodal]');
    if(mv){
      var tpl = mv.closest('[data-al-vcard]') && mv.closest('[data-al-vcard]').querySelector('template');
      if(tpl){
        e.preventDefault();
        var modal = document.createElement('div'); modal.className = 'al-vmodal'; modal.setAttribute('role','dialog'); modal.setAttribute('aria-modal','true');
        modal.innerHTML = '<button type="button" class="al-vmodal__x" aria-label="Close video">&times;</button>';
        modal.appendChild(tpl.content.cloneNode(true));
        document.body.appendChild(modal); document.body.style.overflow = 'hidden';
        var v = modal.querySelector('video'); if(v){ v.controls = true; v.play && v.play().catch(function(){}); }
        var x = modal.querySelector('.al-vmodal__x'); x.focus();
        function shut(){ modal.remove(); document.body.style.overflow = ''; mv.focus(); document.removeEventListener('keydown', onKey); }
        function onKey(ev){ if(ev.key === 'Escape') shut(); }
        document.addEventListener('keydown', onKey);
        modal.addEventListener('click', function(ev){ if(ev.target === modal || ev.target.closest('.al-vmodal__x')) shut(); });
        return;
      }
    }
    var p = e.target.closest('[data-al-play]'); if(!p) return;
    var box = p.closest('.al-media'); var vid = box && box.querySelector('video');
    if(vid){ vid.controls = true; vid.play(); box.classList.add('is-playing'); }
  });

  /* ---------- Product page ---------- */
  function initPdp(root){
    if(root.__al) return; root.__al = true;
    var dataEl = root.querySelector('[data-al-product-json]'); if(!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-al-variant-id]');
    var price = root.querySelectorAll('[data-al-price]');
    var label = root.querySelector('[data-al-opt-label]');
    var atc = root.querySelectorAll('[data-al-atc]');
    var fmt = root.dataset.moneyFormat || '{{amount}}';
    var money = function(c){ return alMoney(c, fmt); };
    root.querySelectorAll('[data-al-swatch]').forEach(function(sw){
      sw.addEventListener('click', function(){
        var v = product.variants.find(function(x){ return String(x.id) === sw.dataset.alSwatch; }); if(!v) return;
        root.querySelectorAll('[data-al-swatch]').forEach(function(o){ o.setAttribute('aria-pressed', o===sw ? 'true':'false'); });
        idInput.value = v.id;
        if(label) label.textContent = sw.dataset.label;
        var html = money(v.price) + (v.compare_at_price && v.compare_at_price > v.price ? ' <s>'+money(v.compare_at_price)+'</s>' : '');
        price.forEach(function(p){ p.innerHTML = html; });
        document.querySelectorAll('[data-al-sticky] [data-al-price]').forEach(function(p){ p.innerHTML = html; });
        atc.forEach(function(b){ b.dataset.variant = v.id; if(v.available){ b.removeAttribute('disabled'); } else { b.setAttribute('disabled',''); } });
        document.querySelectorAll('[data-al-sticky] [data-al-atc]').forEach(function(b){ b.dataset.variant = v.id; });
        if(v.featured_media){ var mm = root.querySelector('[data-media-id="'+v.featured_media.id+'"]'); var first = root.querySelector('.al-gallery__item'); if(mm && first && mm !== first){ first.parentNode.insertBefore(mm, first); } }
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      });
    });
    var qty = root.querySelector('[data-al-qty]');
    root.querySelectorAll('[data-al-qty-step]').forEach(function(b){ b.addEventListener('click', function(){ qty.value = Math.max(1, Number(qty.value||1) + Number(b.dataset.alQtyStep)); }); });
    var form = root.querySelector('[data-al-form]');
    if(form) form.addEventListener('submit', function(e){ e.preventDefault(); alAdd(idInput.value, qty ? qty.value : 1, form.querySelector('[data-al-atc]')); });
    var more = root.querySelector('[data-al-more]');
    if(more) more.addEventListener('click', function(){ var w = root.querySelector('.al-feats-wrap'); w.classList.toggle('is-open'); more.firstChild.textContent = w.classList.contains('is-open') ? 'Show less ' : 'Show more '; });
    var sticky = document.querySelector('[data-al-sticky]');
    var watch = root.querySelector('[data-al-form]');
    if(sticky && watch && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ var r = en[0]; sticky.classList.toggle('is-visible', !r.isIntersecting && r.boundingClientRect.top < 0); }).observe(watch);
    }
  }

  /* ---------- Compare selects ---------- */
  function initCompare(root){
    if(root.__al) return; root.__al = true;
    root.querySelectorAll('[data-al-cmp-select]').forEach(function(sel){
      var col = sel.dataset.alCmpSelect;
      sel.addEventListener('change', function(){
        root.querySelectorAll('[data-al-cmp-col="'+col+'"] [data-al-cmp-panel]').forEach(function(p){ p.hidden = p.dataset.alCmpPanel !== sel.value; });
      });
    });
  }

  /* ---------- Quiz ---------- */
  function initQuiz(root){
    if(root.__al) return; root.__al = true;
    var bar = root.querySelector('[data-al-quiz-bar]');
    var step1 = root.querySelector('[data-al-quiz-step]');
    root.addEventListener('click', function(e){
      var opt = e.target.closest('[data-al-quiz-opt]');
      if(opt){
        step1.hidden = true;
        root.querySelectorAll('[data-al-quiz-result]').forEach(function(r){ r.hidden = r.dataset.alQuizResult !== opt.dataset.alQuizOpt; });
        if(bar) bar.style.width = '100%';
        root.scrollIntoView({behavior:'smooth', block:'start'});
        return;
      }
      if(e.target.closest('[data-al-quiz-restart]')){
        step1.hidden = false;
        root.querySelectorAll('[data-al-quiz-result]').forEach(function(r){ r.hidden = true; });
        if(bar) bar.style.width = bar.dataset.start || '22%';
      }
    });
  }

  /* ---------- Help search ---------- */
  document.addEventListener('input', function(e){
    var s = e.target.closest('[data-al-help-search]'); if(!s) return;
    var q = s.value.trim().toLowerCase();
    document.querySelectorAll('.al-faq__list').forEach(function(list){
      list.removeAttribute('data-collapsed');
      list.querySelectorAll('.al-acc').forEach(function(a){ var hit = !q || a.textContent.toLowerCase().indexOf(q) > -1; a.style.display = hit ? '' : 'none'; if(q && hit) a.open = true; if(!q) a.open = false; });
    });
    document.querySelectorAll('[data-al-faq-more]').forEach(function(b){ b.remove(); });
  });
  document.addEventListener('keydown', function(e){ var s = e.target.closest && e.target.closest('[data-al-help-search]'); if(s && e.key === 'Enter'){ e.preventDefault(); var f = document.querySelector('.al-faq__list'); if(f) f.scrollIntoView({behavior:'smooth'}); } });

  /* ---------- FAQ show more ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-al-faq-more]'); if(!b) return;
    var list = document.getElementById(b.dataset.alFaqMore); if(list){ list.removeAttribute('data-collapsed'); b.remove(); }
  });

  /* ---------- Country / language selector ---------- */
  function store(k, v){ try{ if(v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); }catch(e){ return null; } }
  function sstore(k, v){ try{ if(v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); }catch(e){ return null; } }
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-al-loc-toggle]');
    document.querySelectorAll('.al-loc.is-open').forEach(function(l){ if(!l.contains(e.target)) { l.classList.remove('is-open'); var b=l.querySelector('[data-al-loc-toggle]'); if(b) b.setAttribute('aria-expanded','false'); } });
    if(t){ var loc = t.closest('.al-loc'); var open = !loc.classList.contains('is-open'); loc.classList.toggle('is-open', open); t.setAttribute('aria-expanded', open ? 'true':'false'); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') document.querySelectorAll('.al-loc.is-open').forEach(function(l){ l.classList.remove('is-open'); }); });
  document.addEventListener('submit', function(e){ if(e.target.matches('[data-al-loc-manual]')) store('al_loc_manual', '1'); }, true);
  document.addEventListener('change', function(e){ var s = e.target.closest('[data-al-loc-autosubmit]'); if(s){ store('al_loc_manual','1'); s.form.submit(); } });

  function autoLocalize(){
    var form = document.querySelector('[data-al-loc-auto]'); if(!form) return;
    if(store('al_loc_manual') || sstore('al_loc_checked')) return;
    sstore('al_loc_checked', '1');
    var cur = form.dataset.country || '', lang = form.dataset.language || '';
    var url = '/browsing_context_suggestions.json?country%5Benabled%5D=true&country%5Bexclude%5D=' + encodeURIComponent(cur) + '&language%5Benabled%5D=true&language%5Bexclude%5D=' + encodeURIComponent(lang);
    fetch(url, {headers:{Accept:'application/json'}}).then(function(r){ return r.ok ? r.json() : null; }).then(function(d){
      if(!d || !d.suggestions || !d.suggestions.length) return;
      var parts = d.suggestions[0].parts || {};
      var c = parts.country && parts.country.handle; var l = parts.language && parts.language.handle;
      var changed = false;
      if(c && c !== cur && form.querySelector('[name="country_code"]')){ form.querySelector('[name="country_code"]').value = c; changed = true; }
      if(l && l !== lang && form.querySelector('[name="language_code"]')){ form.querySelector('[name="language_code"]').value = l; changed = true; }
      if(changed) form.submit();
    }).catch(function(){});
  }

  function boot(scope){
    (scope||document).querySelectorAll('[data-al-carousel]').forEach(initRail);
    (scope||document).querySelectorAll('[data-al-pdp]').forEach(initPdp);
    (scope||document).querySelectorAll('[data-al-cmp]').forEach(initCompare);
    (scope||document).querySelectorAll('[data-al-quiz]').forEach(initQuiz);
  }
  function ready(){ initCart(); initMenus(); boot(); if(!(window.Shopify && Shopify.designMode)) autoLocalize(); }
  if(document.readyState !== 'loading') ready(); else document.addEventListener('DOMContentLoaded', ready);
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); initMenus(); });
})();
